import React, {useEffect, useState} from "react";
import {Link, useHistory, useLocation} from "react-router-dom";
import { routes } from "../../../config/pillveryVariables";
import {useDispatch, useSelector} from "react-redux";
import fetchNotificationsAction from "@pillvery/redux/notifications/actions";
import Loader       from '@pillvery/components/utility/loader';
const { fetchNotifications } = fetchNotificationsAction;

export default function TopbarNotifications() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    var dateFormat = require("dateformat");

    const currentUrlParams =  new URLSearchParams(location.search);

    const { notifications, loading } = useSelector(state => state.Notifications);

    const [params, setParams] = useState({
        page: parseInt(currentUrlParams.get("page")) || 1,
        limit: 25,
        sort_type: 'desc',
        sort_field: 'created_at'
    })

    useEffect(()=> {
        dispatch(fetchNotifications(params))
    }, []);

    return (
        <li className="nav-item dropdown topbar-notifications">
            <a className="nav-link count-indicator dropdown-toggle d-flex align-items-center justify-content-center"
               id="notificationDropdown" href="#" data-toggle="dropdown">
                <i className="mdi mdi-bell-outline mx-0"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                 aria-labelledby="notificationDropdown">
                <p className="mb-0 font-weight-normal float-left dropdown-header">
                    Notifications
                    <Link to={ routes.NOTIFICATIONS } className="btn btn-outline-primary" style={{
                        position: "absolute", top: 8, right: 18, borderRadius: 8,
                        height: 30,
                        padding: 7,
                        fontSize: 13,
                    }}>
                        View All
                    </Link>
                </p>

                { loading ? <Loader /> : ''}
                {
                    notifications?.data?.map(notification => (
                        <a className="dropdown-item preview-item">
                            <div className="preview-thumbnail">
                                <div className="preview-icon" style={{border: "1px solid #707070"}}></div>
                            </div>
                            <div className="preview-item-content">
                                <h6 className="preview-subject font-weight-normal">
                                    { notification?.notification?.title}
                                </h6>
                                <p className="font-weight-light small-text mb-0 text-muted">
                                    { dateFormat(notification?.created_at, "dd mmm yyyy - h:MM TT") }
                                </p>
                            </div>
                        </a>
                    ))
                }
            </div>

        </li>
    );
}